// eslint-disable-next-line @typescript-eslint/no-magic-numbers
type CompactRejectedValues = undefined | null | false | 0;
export type Compact<T> = Exclude<T, CompactRejectedValues>;
export type Compactable<T> = T | CompactRejectedValues;

export const compact = <T>(array: ReadonlyArray<T | CompactRejectedValues> | null | undefined): Array<T> => {
   return array?.filter((element): element is T => Boolean(element)) ?? [];
};
